import { useDispatch } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import {
  adminActioninUserReturnRequest,
  getAllReturnOrderRequest,
} from "../../reducers/adminReducers";
import { toast } from "react-toastify";
import { useState } from "react";

const ReturnOrderDetails = ({
  isOpen,
  onClose,
  singleReturnOrderData,
  id,
  setId,
}) => {
  const createAddress = (data) => {
    let address = "";
    if (data) {
      [
        "firstname",
        "lastname",
        "mobile",
        "addressLine1",
        "addressLine2",
        "city",
        "state",
        "country",
        "zipCode",
      ].forEach((el) => {
        if (data[el]) {
          address = `${address ? `${address}` : address} ${data[el]}`;
        }
      });
    }
    return address;
  };

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleAdminAction = (action) => {
    const paylaod = {
      id: id,
      status: action,
    };
    setLoading(true);
    dispatch(adminActioninUserReturnRequest(paylaod)).then((response) => {
      if (response?.payload?.resultData?.code === 200) {
        toast.success(
          response?.payload?.resultData?.msg || "status updated successfully",
          {
            toastId: "success",
          }
        );
        dispatch(getAllReturnOrderRequest()).then(() => {
          setLoading(false);
          setId(null);
          onClose();
        });
      } else {
        toast.error(
          response?.payload?.resultData?.msg || "something went wrong",
          {
            toastId: "error",
          }
        );
        setLoading(false);
      }
    });
  };

  const totalPrice = singleReturnOrderData?.boxDetails?.reduce(
    (total, item) => total + item.boxId.price,
    0
  );

  const boxNameFormatter = (name) => {
    if (!name.includes("~")) {
      return name;
    }
    const splitName = name.split("~");
    return splitName[0];
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="lg">
      <ModalBody>
        <div
          className="order-detail "
          style={{
            maxHeight: "80vh",
            overflow: "auto",
          }}>
          <div className="order-detail-list">
            <h4>User Details</h4>
            <div className="user-name">
              <p>
                Username:{" "}
                <span>{singleReturnOrderData?.userDetails?.username}</span>
              </p>
              <p>
                Phone: <span>{singleReturnOrderData?.userDetails?.mobile}</span>
              </p>
              <p>
                Address:{" "}
                <span>
                  {createAddress(singleReturnOrderData?.userDetails?.address)}
                </span>
              </p>
            </div>
          </div>
          <div className="order-detail-list">
            <h4>Order Details</h4>
            <div className="user-name">
              <p>
                Order No:{" "}
                <span>{singleReturnOrderData?.orderDetails?.orderId}</span>
              </p>
              <p>
                Total Return Order Items:{" "}
                <span>
                  {singleReturnOrderData?.orderDetails?.totalOrderItems}
                </span>
              </p>
            </div>
          </div>
          <div className="order-detail-list">
            {/* <h4>Ordered Items:</h4> */}

            <div className="ordered-detail-list">
              <div className="left-order-details">
                <div className="ordered-items">
                  <img
                    src={singleReturnOrderData?.productDetails?.productImage}
                    alt="ordered"
                  />
                </div>
              </div>
              <div className="right-order-section">
                <div className="user-name">
                  <p>
                    Order Name:{" "}
                    <span>
                      {singleReturnOrderData?.productDetails?.productName}
                    </span>
                  </p>
                  <p>
                    Price:{" "}
                    <span>
                      &euro; {singleReturnOrderData?.productDetails?.price}
                    </span>
                  </p>
                  <p>
                    Orderd Quantity:{" "}
                    <span>
                      {singleReturnOrderData?.productDetails?.quantity}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="order-detail-list">
            <h4>Box Details:</h4>

            {singleReturnOrderData?.boxDetails?.length > 0 &&
              singleReturnOrderData?.boxDetails?.map((el) => (
                <div className="ordered-detail-list">
                  <div className="left-order-details">
                    <div className="ordered-items">
                      <img src={el.boxId.image} alt="ordered" />
                    </div>
                  </div>
                  <div className="right-order-section">
                    <div className="user-name">
                      <p>
                        Order Name: <span>{boxNameFormatter(el?.boxId.name)}</span>
                      </p>
                      <p>
                        Price: <span>$ {el?.boxId?.price}</span>
                      </p>
                    </div>
                  </div>
                </div>
              ))}

            <p className="total-box-price pt-4">
              Total Price Return To User : $ {totalPrice?.toFixed(2)}
            </p>
          </div>

          <div className="order-detail-list">
            <h4>Attachment</h4>
            <img
              className="img-fluid"
              src={singleReturnOrderData?.attachement}
              alt="attachement"
            />
          </div>

          {/* Reason */}
          <div className="order-detail-list">
            <h4>Reason</h4>
            <p>{singleReturnOrderData?.reason}</p>
          </div>

          {/* Message */}
          <div className="order-detail-list">
            <h4>Message</h4>
            <p>{singleReturnOrderData?.message}</p>
          </div>

          {/* Actions */}
          <div
            className=""
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "0.5rem",
            }}>
            <button
              onClick={() => handleAdminAction("approved")}
              disabled={loading || singleReturnOrderData?.status !== "pending"}
              className="btn btn-sm btn-success">
              Approve
            </button>
            <button
              onClick={() => handleAdminAction("rejected")}
              disabled={loading || singleReturnOrderData?.status !== "pending"}
              className="btn btn-sm btn-danger">
              Reject
            </button>
          </div>
        </div>
      </ModalBody>
      ;
    </Modal>
  );
};

export default ReturnOrderDetails;
